<template>
  <div class="ff-item" :class="[type, this.status ? 'grey' : '']">
    <div class="ff-item-inner" :class="getClass">
      <img class="ff-img" :src="imgSrc">
      <span class="item-nums" v-show="nums > 1">X{{nums}}</span>
      <slot></slot>
    </div>
    <div class="ff-item-tick" v-if="purchased"></div>
    <div class="ff-name">
       <p v-if="name" v-marquee class="ff-item-name"><span class="bebas-font">{{name}}</span></p>
    </div>
    <slot name="mask-name"></slot>
  </div>
</template>

<script>
export default {
  props: {
    imgSrc: String,
    name: String,
    nums: Number || String,
    type: String,
    light: String,
    status: Boolean,
    shine: {
      type: Boolean,
      default: false
    },
    purchased: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getClass () {
      return [
        this.type + '-frame',
        this.shine ? 'ff-item-inner__shine' : ''
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.ff-item {
  position: relative;
  @include px2res(width, 116);

  .ff-item-tick {
    position: absolute;
    @include px2res(top, 34);
    @include px2res(left, 28);
    @include px2res(width, 60);
    @include px2res(height, 48);
  }
  .ff-item-inner {
    @include px2res(width, 116);
    @include px2res(height, 116);
    max-width: 100%;
    max-height: 100%;
    position: relative;

    &.ff-item-inner__shine {
      filter: drop-shadow(0 0 10px #f26c00);
    }

    /* &.reward-frame {
      @include px2res(width, 90);
      @include px2res(height, 90);
    } */
    .ff-img {
      max-width: 80%;
      max-height: 80%;
      width: auto;
      height: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .item-nums {
      position: absolute;
      color: #FFDD9C;
      @include px2res(bottom, 6);
      @include px2res(right, 2);
      @include px2res(height, 24);
      @include px2res(line-height, 24);
      @include px2res(font-size, 16);
      @include px2res(padding, 0, 15);
      font-style: italic;
      font-family: inherit;
      z-index: 2;
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 40%,
        rgba(0, 0, 0, 0.5) 60%,
        rgba(0, 0, 0, 0) 100%
      );
    }
  }
  .ff-name {
    width: 100%;
    overflow: hidden;
  }
  .ff-item-name {
    @include px2res(font-size, 32);
    text-align: center;
    white-space: nowrap;
    color: #FDF7C2;
    /* color: #FBED65;
    background:linear-gradient(0deg,rgba(251,237,101,1) 0%, rgba(255,255,255,1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent; */
  }
  .ff-item.light{
    box-shadow: 0 0 2px 10px #ffdc51;
  }
  .drawn-frame .ff-img {
    filter: grayscale(1);
  }
}
.ff-claimed {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  @include px2res(width, 88);
  @include px2res(height, 88);
  background-size: 98% auto;
}
.grey .ff-item-inner {
  filter: grayscale(1) brightness(.8);
}
.ff-item.light {
  box-shadow: 0 0 8px 2px rgba(255, 220, 81, .8);
}
.ff-item .feature-reward-frame {
  @include px2res(width, 200);
  @include px2res(height, 200);
  .item-nums {
    @include px2res(font-size, 24);
    @include px2res(height, 30);
    @include px2res(line-height, 30);
    @include px2res(right, 12);
    @include px2res(bottom, 10);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Item.vue